import { values } from 'lodash';
export const nodeByDescriptionSortFn = (a, b) => a.description > b.description ? 1 : -1;
export const definePathArray = (hash, id) => {
    const item = hash[id];
    const { parent_id: parentId } = item;
    if (!parentId)
        return [id];
    const parentPathArray = definePathArray(hash, parentId);
    return [...parentPathArray, id];
};
export const getDescendantTree = (hash, id) => {
    const item = hash[id];
    if (!item)
        return [];
    const { nodes: nodesIds } = item;
    if (!nodesIds.length)
        return [];
    const nodes = nodesIds.reduce((acc, nid) => {
        const nodeItem = hash[nid];
        if (nodeItem)
            return [...acc, nodeItem];
        return acc;
    }, []);
    if (!nodes.length)
        return [];
    const nodesSorted = nodes.sort(nodeByDescriptionSortFn);
    const nodesSortedIds = nodesSorted.map((node) => node.id);
    return nodesSortedIds.reduce((acc, nodeId) => [...acc, nodeId, ...getDescendantTree(hash, nodeId)], []);
};
export const getHierarchiesPathsMap = (hash) => {
    const pathsHash = {};
    const processNode = (node, path) => {
        const { id, nodes = [] } = node;
        if (!pathsHash?.[id])
            pathsHash[id] = path;
        const childPath = [...path, id];
        nodes.forEach((nodeId) => {
            if (nodeId in hash)
                processNode(hash[nodeId], childPath);
        });
    };
    values(hash)
        .filter((node) => !node.parent_id)
        .forEach((node) => {
        processNode(node, []);
    });
    return pathsHash;
};
export const getHierarchyHashFromModelEntityHierarchy = (modelNodesPath) => modelNodesPath.reduce((acc, n) => ({
    ...acc,
    [n.id]: n
}), {});
